import React from "react";

/* img imports */
import aboutBoard from "../assets/images/about-us-board.png";

const AboutUsBoard = ({ handleRedirect }) => {
  return (
    <>
      <div
        className="about-board-wrapper"
        onClick={() => {
          handleRedirect("/about-us");
        }}
      >
        <img src={aboutBoard} alt="" />
      </div>
    </>
  );
};

export default AboutUsBoard;
